<div [class]="cssClasses()" class="notification" role="alert" aria-live="assertive">
  <div class="notification__wrapper">
    @if (icon()) {
      <div>
        <ds-icon [set]="config().iconset" [name]="icon()!" />
      </div>
    }

    <div class="notification__content">
      <span class="notification__content__title">{{ config().title }}</span>
      @if (config().description) {
        <div class="notification__content__description" [innerHTML]="config().description"></div>
      }
    </div>

    @if (config().dismissable) {
      <ds-button
        class="notification__close"
        variant="iconOnlySubtle"
        ariaLabel="Sluit notificatie"
        (click)="closeNotification()"
      >
        <ds-icon name="close" />
      </ds-button>
    }
  </div>

  @if (config().duration) {
    <div
      class="notification__progress"
      [class.notification__progress--paused]="isPaused()"
      [style.--notification-duration]="animationDuration()"
      role="progressbar"
      aria-label="Notificatie verdwijnt automatisch"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="isPaused() ? 'paused' : null"
    >
      <div class="notification__progress-bar"></div>
    </div>
  }
</div>
